import EmergencyTravelCertsModule from '@features/Consular/components/emergency-travel/EmergencyTravelCerts.Module';

const EmergencyTravelCerts = () => {
  return <EmergencyTravelCertsModule />;
};

export default EmergencyTravelCerts;
